import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Container, Content, CustomProvider, DOMHelper } from 'rsuite';
import Header from './Header';
import {
  isExpanded,
  selectSidemenu
} from '@monorepo/shared/store/sidemenuSlice';
import serviceTermPdf from '/SD-CloudServices-FortiSOAR.pdf';
import { Footer } from '@monorepo/shared/components';
import { EnvConst, host, server } from '../config/const';
import {
  getSafeUrl,
  ModalAlert,
  useGetSystemDataQuery
} from '@monorepo/shared';
import { selectSessionStatus } from '@monorepo/shared/store/authSlice';

import * as locales from 'rsuite/locales';
import { getNavigatorLanguage, useAppSelector } from '@monorepo/shared';
import { selectCurrentLocale } from '@monorepo/shared/store/authSlice';
import { useTranslation } from 'react-i18next';
import { jaJP } from '@monorepo/shared/i18n/jaJP/rsLocale';
import '@monorepo/shared/i18n/config';
import { Sidemenu } from './SidemenuNew';

const { getHeight, on } = DOMHelper;

export interface FrameProps {
  hideSideMenu?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  children?: React.ReactNode;
}

const Frame = ({
  children,
  hideSideMenu,
  hideHeader,
  hideFooter
}: FrameProps) => {
  const menuExpanded = useAppSelector(isExpanded);
  const sessionStatus = useAppSelector(selectSessionStatus);
  const [windowHeight, setWindowHeight] = useState<number>(getHeight(window));
  const headerHeight = 52;
  const footerHeight = 40;
  const [containerHeight, setContainerHeight] = useState<number>(windowHeight);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  // const logOutURL = getSafeUrl(`${EnvConst.auth_host}/ssologout/`);
  const logOutURL = getSafeUrl(`${server}`);
  const logInUrl = getSafeUrl(
    `${EnvConst.auth_host}/ssologin/?next=${host}/cred/ou`
  );

  const languages: Record<string, any> =
    locales && jaJP ? { ...locales, jaJP: jaJP } : {};
  const currentLocale: string = useAppSelector(selectCurrentLocale);
  const [localeVal, setLocaleVal] = useState<any>();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (locales && Object.keys(languages).length) {
      const locale =
        currentLocale === 'auto' ? getNavigatorLanguage() : currentLocale;
      const value = languages[locale];
      if (value) {
        setLocaleVal(value);
        i18n.changeLanguage(locale);
      } else if (locale === 'jaJP') {
        setLocaleVal(jaJP);
        i18n.changeLanguage(locale);
      }
    }
  }, [currentLocale]);
  useEffect(() => {
    setWindowHeight(getHeight(window));
    const resizeListener = on(window, 'resize', () =>
      setWindowHeight(getHeight(window))
    );

    return () => {
      resizeListener.off();
    };
  }, []);

  useEffect(() => {
    if (sessionStatus === 'EXPIRED') {
      setAlertOpen(true);
    } else if (sessionStatus === 'REVOKED') {
      window.open(getSafeUrl(`${server}`), '_self');
    }
  }, [sessionStatus]);
  const containerClasses = classNames('page-container', {
    'container-full': !menuExpanded
  });

  useEffect(() => {
    let height = windowHeight;
    if (!hideHeader) {
      height -= headerHeight;
    }
    if (!hideFooter) {
      height -= footerHeight;
    }

    setContainerHeight(height);
  }, [hideHeader, hideFooter, windowHeight]);

  return (
    <CustomProvider locale={localeVal}>
      <div style={{ height: windowHeight }}>
        <Header
          hideSideMenu={hideSideMenu}
          style={{
            height: headerHeight,
            display: hideHeader ? 'none' : 'flex'
          }}
        />
        <Container
          className="frame-container"
          style={{ height: containerHeight }}
        >
          <Container
            className={containerClasses}
            style={{
              height: `${containerHeight}px`
            }}
          >
            {!hideSideMenu && <Sidemenu />}
            <Content
              style={{
                // height: `${containerHeight}px`
                height: '100%',
                overflow: 'hidden'
              }}
            >
              {children}
            </Content>
          </Container>
        </Container>
        <Footer
          pdf={serviceTermPdf}
          style={{
            height: footerHeight,
            display: hideFooter ? 'none' : 'flex'
          }}
          server={server}
        ></Footer>
        <ModalAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          logInUrl={logInUrl}
          logOutUrl={logOutURL}
        ></ModalAlert>
      </div>
    </CustomProvider>
  );
};

export default Frame;
